import { useState } from "react";
import { Volume2, VolumeX } from "lucide-react";
import { ROLES } from "../../game/roles";
import { sfx } from "../../lib/sfx";
import { StrawHat } from "./StrawHat";
import { HowToPlay } from "./HowToPlay";

const SoundToggle = () => {
  const [muted, setMuted] = useState(sfx.isMuted());
  const toggle = () => {
    sfx.setMuted(!muted);
    setMuted(!muted);
  };
  return (
    <button
      type="button"
      onClick={toggle}
      data-testid="sound-toggle"
      aria-label={muted ? "Attiva suoni" : "Disattiva suoni"}
      className="w-10 h-10 rounded-full bg-white border border-[#D0E4F3] flex items-center justify-center text-[#147E9D] active:scale-95 transition-transform"
    >
      {muted ? <VolumeX size={18} className="text-[#506780]" /> : <Volume2 size={18} />}
    </button>
  );
};

export const GameHeader = ({ filled }) => (
  <header className="flex items-end justify-between gap-4 pb-5" data-testid="game-header">
    <div>
      <p className="label-mono text-[#147E9D]">Gioco fan-made · Lumacofono</p>
      <h1 className="relative font-display text-[1.75rem] leading-[0.95] text-[#14233D] mt-4" data-testid="game-title">
        <StrawHat />
        COSTRUISCI<br />
        LA TUA <span className="text-pop">CIURMA</span>
      </h1>
      <HowToPlay />
    </div>
    <div className="flex items-center gap-3">
    <SoundToggle />
    <div className="floaty text-center rounded-[22px] bg-white px-4 py-2 shadow-[0_5px_0_#7433C1]" data-testid="crew-progress">
      <p className="label-mono text-[9px] text-[#7433C1]">Ciurma</p>
      <p className="font-display text-3xl text-[#14233D] leading-none mt-0.5">
        {filled}
        <span className="text-[#C64BB4]">/{ROLES.length}</span>
      </p>
    </div>
    </div>
  </header>
);
